import styled from 'styled-components/macro';
import * as PopoverPrimitive from '@radix-ui/react-popover';

export const PopoverTrigger = styled(PopoverPrimitive.Trigger)`
  background: unset;
  border: unset;
  padding: unset;
`;
